const Api = {
    
    main: {
        customer: "/main/customers",
        customer_address: "/main/customers/addresses",
        category: "/main/categories",
        product: "/main/products",
        vendor: "/main/vendors",
        employee: "/main/employees",
        card_flag: "/main/card-flags",
        branch: "/main/branches",
        branch_working_hours: "/main/branch-working-hours"
    },
    appointment: {
        appointment: "/appointments",
        block: "/appointment-blocks",
        deposit: "/appointment-deposits",
        onlinePenalty: "/appointment-online-penalties",
        special_day: "/appointment-special-days",
        schedule: "/appointments/schedule",
        updateStatus: "/appointments/update-status",
        bulkUpdateStatus: "/appointments/bulk-update-status",
        byCustomer: "/appointments/customer",
        byEmployee: "/appointments/employee", 
        byStatus: "/appointments/status",
        byUuid: "/appointments/uuid",
        review: "/appointment-reviews"
    },
    notification: {
        base: "/notifications",
        readAll: "/notifications/read-all"
    },
    sales: {
        order: "/sales/orders",
        order_checkout_search: "/sales/orders/checkout/search",
        order_item: "/sales/orders/items",
        commission_rule: "/sales/commission-rules",
        reason: "/sales/reasons",
        visual_chart: "/sales/visual/charts",
        visual_calculation: "/sales/visual/calculation",
        visual_report: "/sales/visual/reports",
        visual_bi: "/sales/visual/bi",
    },
    reports: {
        employee_statement: "/reports/employee-statement",
        pot: "/reports/pot",
        extra_services: "/reports/sales",
    },
    gamification: {
        score: "/gamification/scores",
        pot: "/gamification/pots",
        potAdjustment: "/gamification/pot-adjustments",
        scoreAdjustment: "/gamification/score-adjustments",
        pot_bonus_rule: "/gamification/pot-bonus-rules",
    },
    performance: {
        plan: "/performance/plans",
        employee_plan: "/performance/employees/plans",
        dashboard: "/performance/dashboard",
        highlight: "/performance/dashboard/highlight",
        highlightSubscriptionsWithoutSeller: "/performance/dashboard/highlight/subscriptions-without-seller",
        categoryTickets: "/performance/dashboard/category-tickets",
        reports: "/performance/reports",
    },
    subscription: {
        plan: "/subscription/plans",
        subscription: "/subscription/subscriptions",
        analytics: "/subscription/analytics",
        charge: "/subscription/charges",
        club_partner: "/club-partners"
    },
    parameter: {
        efi: "parameters/efi",
        asaas: "parameters/asaas",
        asaas_superadmin: "parameters/asaas/superadmin",
        celcoin: "parameters/celcoin",
        celcoin_superadmin: "parameters/celcoin/superadmin",
        celcoin_public_config: "parameters/celcoin/public-config",
        gamification: "parameters/gamification",
        sales: "parameters/sales",
        main: "parameters/main",
        stock_control: "parameters/stock-control",
        whatsapp: "/parameters/whatsapp",
        whatsapp_disconnect: "/parameters/whatsapp/disconnect",
        whatsapp_account_health: "/parameters/whatsapp/account-health",
        whatsapp_meta_setup_info: "/parameters/whatsapp/meta-setup-info",
        whatsapp_embedded_signup: "/parameters/whatsapp/embedded-signup",
        whatsapp_register_number: "/parameters/whatsapp/register-number",
        whatsapp_subscribe_app: "/parameters/whatsapp/subscribe-app",
        whatsapp_template_models: "/parameters/whatsapp/template-models",
        whatsapp_template_models_sync: "/parameters/whatsapp/template-models/sync",
        whatsapp_template_message_status: "/parameters/whatsapp/template-messages",
        whatsapp_billing_issue: "/parameters/whatsapp/billing-issue",
        // Plataforma (super admin): conexão manual do WhatsApp das empresas com app próprio da Meta.
        whatsapp_superadmin: "/parameters/whatsapp/superadmin",
        chatbot: "/parameters/chatbot",
        appointment: "parameters/appointment",
        employeeHighlight: "parameters/employee-highlight"
    },
    integration: {
        payment: "integration/payment",
        asaas: "integration/asaas",
        // Super admin: endpoints que aceitam companyId explícito para operar em outras empresas
        asaas_sync_superadmin: "integration/asaas/sync",
        celcoin_sync_superadmin: "integration/celcoin/sync",
        payment_sync_job: "integration/payment/sync-jobs"
    },
    registration: {
        company: "registration/companies",
        company_superadmin: "/registration/companies/superadmin",
        company_cnpj_lookup: "/registration/companies/superadmin/cnpj",
        company_provision: "/registration/companies/provision",
        company_info: "/registration/companies/info",
        company_logo: "/registration/companies/logo",
        company_banner: "/registration/companies/banner",
        company_branding: "/registration/companies/branding",
        company_public_page: "/registration/companies/public-page"
    },
    identity: {
        user: "identity/users",
        group: "identity/groups",
        permission: "identity/permissions",
        // Só os módulos contratados pela empresa logada, para as telas internas não
        // oferecerem acesso a um módulo que a empresa não tem.
        permission_company: "identity/permissions/company",
        group_permission: "identity/groups/permissions",
        group_menu_permission: "identity/groups/menu-permissions"
    },
    stock_control: {
        restock: "stock-control/movements",
        stock: "stock-control/stocks"
    },
    cash_flow: {
        cash: "cash-flow/cashes",
        transaction: "cash-flow/transactions",
        payable_receivable: "cash-flow/payable-receivable",
        category: "cash-flow/categories",
        dre: "cash-flow/dre",
        import: "cash-flow/import",
        advance: "cash-flow/advances",
        employee_consumption: "cash-flow/employee-consumptions",
        employee_payment: "cash-flow/employee-payments",
        employee_bonus: "cash-flow/employee-bonuses",
    },

    // Cobranças

    whatsapp: {
        bot: "/whatsapp/bots",
        bot_upload: "/whatsapp/bots/upload",
        conversation: "/whatsapp/conversations",
        conversation_metrics: "/whatsapp/conversations/metrics",
        attendance_metrics: "/whatsapp/conversations/attendance-metrics",
        drop_off_metrics: "/whatsapp/conversations/drop-off-metrics",
        message_log: "/whatsapp/message-logs"
    },

    // API Pública
    public_api: {
        common: "/api/public/common"
    }
}

export default Api;
